/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ServiceArgs } from "@reservauto/react-shared/services/AuthenticatedServiceBase";
import FrontOfficeServiceBase from "../../shared/FrontOfficeServiceBase";
import { FetchPromise } from "@reservauto/react-shared/services/ServiceBase";
import * as dto from "./dto";

export interface AccountWarningsService_GetAccountWarning<T> extends ServiceArgs<T> {
}

export class AccountWarningsService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/AccountWarning";

    /**
     * @return OK
     */
    public getAccountWarning<T>(params?: AccountWarningsService_GetAccountWarning<T>): FetchPromise<dto.AccountWarningListDTO> {
       return this.authorizedGet({
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface AvailableAccessCardTypesService_GetAvailableAccessCardType<T> extends ServiceArgs<T> {
}

export class AvailableAccessCardTypesService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/AvailableAccessCardType";

    /**
     * @return OK
     */
    public getAvailableAccessCardType<T>(params?: AvailableAccessCardTypesService_GetAvailableAccessCardType<T>): FetchPromise<dto.AvailableAccessCardTypeListDTO> {
       return this.authorizedGet({
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface AvailableBranchesService_GetAvailableBranch<T> extends ServiceArgs<T> {
    branchId?: number;
    includeUnrelated?: boolean;
}

export class AvailableBranchesService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/AvailableBranch";

    /**
     * @param branchId (optional) 
     * @param includeUnrelated (optional) 
     * @return OK
     */
    public getAvailableBranch<T>(params: AvailableBranchesService_GetAvailableBranch<T>): FetchPromise<dto.AvailableBranchListDTO> {
       return this.authorizedGet({
            queryParams: {
                "branchId": params.branchId,
                "IncludeUnrelated": params.includeUnrelated,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface AvailableFeaturesService_GetAvailableFeature<T> extends ServiceArgs<T> {
    branchId?: number;
}

export class AvailableFeaturesService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/AvailableFeature";

    /**
     * @param branchId (optional) 
     * @return OK
     */
    public getAvailableFeature<T>(params: AvailableFeaturesService_GetAvailableFeature<T>): FetchPromise<dto.AvailableFeatureListDTO> {
       return this.authorizedGet({
            queryParams: {
                "BranchId": params.branchId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface AvailablePaymentMethodTypesService_GetAvailablePaymentMethodType<T> extends ServiceArgs<T> {
}

export class AvailablePaymentMethodTypesService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/AvailablePaymentMethodType";

    /**
     * @return OK
     */
    public getAvailablePaymentMethodType<T>(params?: AvailablePaymentMethodTypesService_GetAvailablePaymentMethodType<T>): FetchPromise<dto.AvailablePaymentMethodTypeListDTO> {
       return this.authorizedGet({
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface AvailablePhoneTypesService_GetAvailablePhoneType<T> extends ServiceArgs<T> {
    branchId?: number;
}

export class AvailablePhoneTypesService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/AvailablePhoneType";

    /**
     * @param branchId (optional) 
     * @return OK
     */
    public getAvailablePhoneType<T>(params: AvailablePhoneTypesService_GetAvailablePhoneType<T>): FetchPromise<dto.AvailablePhoneTypeListDTO> {
       return this.authorizedGet({
            queryParams: {
                "BranchId": params.branchId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface CacheService_DeleteCache<T> extends ServiceArgs<T> {
    cacheKey: dto.EFrontOfficeCacheKey;
}

export interface CacheService_GetCache<T> extends ServiceArgs<T> {
    cacheKey: dto.EFrontOfficeCacheKey;
    filterString?: string;
}

export interface CacheService_DeleteInternal<T> extends ServiceArgs<T> {
    cacheKey: dto.EInternalCacheKey;
}

export class CacheService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/Cache/";

    /**
     * @return No Content
     */
    public deleteCache<T>(params: CacheService_DeleteCache<T>): FetchPromise<void> {
       return this.authorizedDelete({
            pathParams: {
                "cacheKey": params.cacheKey,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "{cacheKey}",
        });
    }

    /**
     * @param filterString (optional) 
     * @return OK
     */
    public getCache<T>(params: CacheService_GetCache<T>): FetchPromise<dto.RestAPICachingInfoDTO> {
       return this.authorizedGet({
            pathParams: {
                "cacheKey": params.cacheKey,
            },
            queryParams: {
                "filterString": params.filterString,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "{cacheKey}",
        });
    }

    /**
     * @return No Content
     */
    public deleteInternal<T>(params: CacheService_DeleteInternal<T>): FetchPromise<void> {
       return this.authorizedDelete({
            pathParams: {
                "cacheKey": params.cacheKey,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "Internal/{cacheKey}",
        });
    }
}

export interface CountriesService_GetCountry<T> extends ServiceArgs<T> {
}

export interface CountriesService_GetState<T> extends ServiceArgs<T> {
    countryIso3166_1Alpha_3Code: string;
}

export class CountriesService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/Country";

    /**
     * @return OK
     */
    public getCountry<T>(params?: CountriesService_GetCountry<T>): FetchPromise<dto.CountryListDTO> {
       return this.authorizedGet({
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }

    /**
     * @return OK
     */
    public getState<T>(params: CountriesService_GetState<T>): FetchPromise<dto.CountryStateListDTO> {
       return this.authorizedGet({
            pathParams: {
                "countryIso3166_1Alpha_3Code": params.countryIso3166_1Alpha_3Code,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "/{countryIso3166_1Alpha_3Code}/State",
        });
    }
}

export interface CreditCardProviderService_GetCreditCardProvider<T> extends ServiceArgs<T> {
}

export interface CreditCardProviderService_GetNetBanx<T> extends ServiceArgs<T> {
}

export interface CreditCardProviderService_GetAdyen<T> extends ServiceArgs<T> {
}

export class CreditCardProviderService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/CreditCardProvider";

    /**
     * @return OK
     */
    public getCreditCardProvider<T>(params?: CreditCardProviderService_GetCreditCardProvider<T>): FetchPromise<dto.CreditCardProviderDetailDTO> {
       return this.authorizedGet({
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }

    /**
     * @return OK
     */
    public getNetBanx<T>(params?: CreditCardProviderService_GetNetBanx<T>): FetchPromise<dto.CreditCardProviderNetBanxDetailDTO> {
       return this.authorizedGet({
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "/NetBanx",
        });
    }

    /**
     * @return OK
     */
    public getAdyen<T>(params?: CreditCardProviderService_GetAdyen<T>): FetchPromise<dto.CreditCardProviderAdyenDetailDTO> {
       return this.authorizedGet({
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "/Adyen",
        });
    }
}

export interface CustomerCommentService_PostCustomerComment<T> extends ServiceArgs<T> {
    reasonId?: number;
    subject?: string;
    message?: string;
    files?: FileParameter[];
    anonymousCommentInfo_BranchId?: number;
    anonymousCommentInfo_LanguageId?: number;
    anonymousCommentInfo_FirstName?: string;
    anonymousCommentInfo_LastName?: string;
    anonymousCommentInfo_Email?: string;
    anonymousCommentInfo_Gender?: dto.EFOGender;
    anonymousCommentInfo_PostalCode?: string;
}

export class CustomerCommentService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/CustomerComment";

    /**
     * @param reasonId (optional) 
     * @param subject (optional) 
     * @param message (optional) 
     * @param files (optional) 
     * @param anonymousCommentInfo_BranchId (optional) 
     * @param anonymousCommentInfo_LanguageId (optional) 
     * @param anonymousCommentInfo_FirstName (optional) 
     * @param anonymousCommentInfo_LastName (optional) 
     * @param anonymousCommentInfo_Email (optional) 
     * @param anonymousCommentInfo_Gender (optional) 
     * @param anonymousCommentInfo_PostalCode (optional) 
     * @return Created
     */
    public postCustomerComment<T>(params: CustomerCommentService_PostCustomerComment<T>): FetchPromise<void> {
       return this.authorizedPost({
            formParams: {
                "ReasonId": params.reasonId,
                "Subject": params.subject,
                "Message": params.message,
                "Files": params.files,
                "AnonymousCommentInfo.BranchId": params.anonymousCommentInfo_BranchId,
                "AnonymousCommentInfo.LanguageId": params.anonymousCommentInfo_LanguageId,
                "AnonymousCommentInfo.FirstName": params.anonymousCommentInfo_FirstName,
                "AnonymousCommentInfo.LastName": params.anonymousCommentInfo_LastName,
                "AnonymousCommentInfo.Email": params.anonymousCommentInfo_Email,
                "AnonymousCommentInfo.Gender": params.anonymousCommentInfo_Gender,
                "AnonymousCommentInfo.PostalCode": params.anonymousCommentInfo_PostalCode,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface CustomerCommentAvailableReasonService_GetAvailableReason<T> extends ServiceArgs<T> {
    branchId?: number;
}

export class CustomerCommentAvailableReasonService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/CustomerComment/AvailableReason";

    /**
     * @param branchId (optional) 
     * @return OK
     */
    public getAvailableReason<T>(params: CustomerCommentAvailableReasonService_GetAvailableReason<T>): FetchPromise<dto.CustomerCommentAvailableReasonListDTO> {
       return this.authorizedGet({
            queryParams: {
                "BranchId": params.branchId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface DamageReportService_GetRedirectURL<T> extends ServiceArgs<T> {
    rentalId?: number;
    cityId?: number;
    vehicleId?: number;
}

export class DamageReportService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/DamageReport/RedirectURL";

    /**
     * @param rentalId (optional) 
     * @param cityId (optional) 
     * @param vehicleId (optional) 
     * @return OK
     */
    public getRedirectURL<T>(params: DamageReportService_GetRedirectURL<T>): FetchPromise<dto.DamageReportRedirectUrlDTO> {
       return this.authorizedGet({
            queryParams: {
                "rentalId": params.rentalId,
                "cityId": params.cityId,
                "vehicleId": params.vehicleId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface EndpointLastUpdateInfoService_GetEndpointLastUpdateInfo<T> extends ServiceArgs<T> {
    branchId?: number;
    cityId?: number;
}

export class EndpointLastUpdateInfoService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/EndpointLastUpdateInfo";

    /**
     * @param branchId (optional) 
     * @param cityId (optional) 
     * @return OK
     */
    public getEndpointLastUpdateInfo<T>(params: EndpointLastUpdateInfoService_GetEndpointLastUpdateInfo<T>): FetchPromise<dto.EndpointLastUpdateInfoListDTO> {
       return this.authorizedGet({
            queryParams: {
                "BranchId": params.branchId,
                "CityId": params.cityId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface LocalizedTextService_GetLocalizedText<T> extends ServiceArgs<T> {
    branchId?: number;
    lastClientUpdatedDate?: Date;
    module?: dto.ELocalizedTextModule;
    type?: dto.ELocalizedTextType;
}

export class LocalizedTextService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/LocalizedText";

    /**
     * @param branchId (optional) 
     * @param lastClientUpdatedDate (optional) 
     * @param module (optional) 
     * @param type (optional) 
     * @return OK
     */
    public getLocalizedText<T>(params: LocalizedTextService_GetLocalizedText<T>): FetchPromise<dto.LocalizedTextListDTO> {
       return this.authorizedGet({
            queryParams: {
                "BranchId": params.branchId,
                "LastClientUpdatedDate": params.lastClientUpdatedDate,
                "Module": params.module,
                "Type": params.type,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface LogService_PostLog<T> extends ServiceArgs<T> {
    body?: dto.LogCreateDTO;
}

export interface LogService_PostCSPReport<T> extends ServiceArgs<T> {
    body?: dto.LogCSPReportCreateDTO;
}

export class LogService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/Log";

    /**
     * @param body (optional) 
     * @return Created
     */
    public postLog<T>(params: LogService_PostLog<T>): FetchPromise<dto.LogDetailDTO> {
       return this.authorizedPost({
            postData: params.body,
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    public postCSPReport<T>(params: LogService_PostCSPReport<T>): FetchPromise<void> {
       return this.authorizedPost({
            postData: params.body,
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "/CSPReport",
        });
    }
}

export interface MapLegendService_GetLegend<T> extends ServiceArgs<T> {
    branchId?: number;
    cityId?: number;
}

export class MapLegendService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/Map/Legend";

    /**
     * @param branchId (optional) 
     * @param cityId (optional) 
     * @return OK
     */
    public getLegend<T>(params: MapLegendService_GetLegend<T>): FetchPromise<dto.MapLegendListDTO> {
       return this.authorizedGet({
            queryParams: {
                "BranchId": params.branchId,
                "CityId": params.cityId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface PushNotificationDeviceService_PostDevice<T> extends ServiceArgs<T> {
    body?: dto.PushNotificationDeviceCreateDTO;
}

export interface PushNotificationDeviceService_DeleteDevice<T> extends ServiceArgs<T> {
    token?: string;
}

export class PushNotificationDeviceService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/PushNotification/Device";

    /**
     * @param body (optional) 
     * @return Created
     */
    public postDevice<T>(params: PushNotificationDeviceService_PostDevice<T>): FetchPromise<dto.PushNotificationDeviceDetailDTO> {
       return this.authorizedPost({
            postData: params.body,
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }

    /**
     * @param token (optional) 
     * @return No Content
     */
    public deleteDevice<T>(params: PushNotificationDeviceService_DeleteDevice<T>): FetchPromise<void> {
       return this.authorizedDelete({
            queryParams: {
                "token": params.token,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
        });
    }
}

export interface TaskProgressService_GetTaskProgressById<T> extends ServiceArgs<T> {
    taskProgressId: number;
}

export class TaskProgressService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/TaskProgress/";

    /**
     * @return OK
     */
    public getTaskProgressById<T>(params: TaskProgressService_GetTaskProgressById<T>): FetchPromise<dto.TaskProgressDetailDTO> {
       return this.authorizedGet({
            pathParams: {
                "taskProgressId": params.taskProgressId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "{taskProgressId}",
        });
    }
}

export interface FileParameter extends File {}
